/**
 * Brand Utilities - Centralized brand ID management
 * 
 * This module provides a single source of truth for the current brand ID.
 * The brand ID is resolved at build time via Vite's environment variable injection.
 * 
 * All components should import BRAND_ID from this module instead of
 * duplicating the environment variable access logic.
 */

/**
 * Current brand ID - resolved at build time
 * This is set via Vite's define in vite.config.ts based on VITE_BRAND_ID env var
 */
export const BRAND_ID: string = import.meta.env.VITE_BRAND_ID || 'citizensInfo';

// Log brand ID on module load for debugging
console.log(`🏷️ Brand ID resolved at build time: ${BRAND_ID}`);

/**
 * Get the current brand ID
 * @returns The current brand identifier
 */
export function getBrandId(): string {
  return BRAND_ID;
}

/**
 * Type guard to check if a string is a valid brand ID
 * This helps with TypeScript type narrowing
 */
export function isValidBrandId(id: string): id is 'citizensInfo' | 'udaras' {
  return id === 'citizensInfo' || id === 'udaras';
}

